<script>
    import { convert } from "./ui";
    import { res, findCard, findCardByName } from "./stores";
    import { allActions, allTokenTypes } from "./card_actions";
    import LogCard from "./LogCard.svelte";
    import { allScoreableCards } from "./scores";
    import { hasOwnProperty } from "fast-json-patch/module/helpers";
    import ActionBit from "./ActionBit.svelte";

    let flatVP;
    export let p;
    export let cards;

    

    function filterCards(){
        let processedIDs = [];
        let newCards = [];
        for(let c of cards){
            if(!processedIDs.includes(c.id)){
                processedIDs.push(c.id);
                newCards.push(c);
            }
        }
        cards = newCards;
    }

    $: filterCards(cards);

    // just do once for now, but could make reactive if xthere are rendering issues
    

    let categories = []; //divvyCardTypes(p, cards);

    $: categories = divvyCardTypes(p, cards);

     function byPlayCount(a,b){
        let aCount = 0;
        let bCount = 0;
        if(a.stats){
            aCount += a.stats.play || 0;
            aCount += a.stats.activate || 0;
            aCount += a.stats.reaction || 0;
            aCount += a.stats.complete || 0;
            aCount += a.stats.control || 0;
        }
        if(b.stats){
            bCount += b.stats.play || 0;
            bCount += b.stats.activate || 0;
            bCount += b.stats.reaction || 0;
            aCount += b.stats.complete || 0;
            aCount += b.stats.control || 0;
        }
        return bCount - aCount;
    }

    function divvyCardTypes(p, cards){
        // Returns {name, group} where group is an array of three bits
        
        let categories = [
            {
                name: 'Market cards',
                group: []
            },
            {
                name: 'Encounters',
                group: []
            },
            {
                name: 'Completed missions',
                group: []
            },
            {
                name: 'Deck cards',
                group: []
            },
            {
                name: 'Common locations',
                group: []
            },
            {
                name: 'Incidents',
                group: []
            },
            {
                name: 'Other',
                group: []
            }
        ]
        for(let c of cards){
            let score = 0;
            if(p.scoreBreakdown.individualCards && p.scoreBreakdown.individualCards[c.id]) score = p.scoreBreakdown.individualCards[c.id];
            if(findCard($res.cards, c.id)){
                c = {...findCard($res.cards, c.id), score, ...c};
            }else if(findCardByName($res.cards, c.name)){
                c = {...$res.cards.filter(c => c.deck == 'Common' || c.deck == 'Locations' || c.deck == p.captain).find(cd => cd.name == c.name), score, ...c};
            }else{
                //console.log('card no longer in database, so cannot categorise it for score', c);
            }
            if(!c.suits || c.suits.includes('mission')){
                if(c.complete) categories.find(t => t.name == 'Completed missions').group.push(c);
            }else if(c.suits.includes('encounter')){
                categories.find(t => t.name == 'Encounters').group.push(c);
            }else if(c.suits.includes('incident')){
                categories.find(t => t.name == 'Incidents').group.push(c);
            }else if(c.deck == 'Common' && !c.suits.includes('directive')){
                categories.find(t => t.name == 'Market cards').group.push(c);
            }else if(c.deck == p.captain){
                categories.find(t => t.name == 'Deck cards').group.push(c);
            }else if(c.deck == 'Locations'){
                categories.find(t => t.name == 'Common locations').group.push(c);
            }else{
                categories.find(t => t.name == 'Other').group.push(c);
            }
        }

        flatVP = 0;

        for(let g of categories){
            let flat = [];
            let mult = [];
            let cond = [];
            for(let c of g.group){
                if(c.stripe && c.stripe.length > 0){
                    mult.push(c);
                }else if(c.vp || !isNaN(c.vp) || c.complete){
                    flat.push(c);
                    if(c.score && !c.hasOwnProperty('endGameScore') && (!c.goal || !c.goal.includes('Endgame'))){
                        flatVP += (c.score || 0);
                    }else{
                        flatVP += (c.vp || 0);
                    }
                    
                }
                if(c.goal && c.goal.includes('Endgame:') || c.hasOwnProperty('endGameScore') || !c.stripe && !c.hasOwnProperty('vp') && !c.complete && c.hasOwnProperty('score') && c.score != 0){
                    let copy = {...c};
                    if(c.hasOwnProperty('endGameScore')){
                        copy.score = c.endGameScore;
                    }else if(c.id && p.scoreBreakdown.endGameSpecific.hasOwnProperty(c.id.replaceAll(`/`, `_`))){
                        copy.score = p.scoreBreakdown.endGameSpecific[c.id.replaceAll(`/`, `_`)] + (c.vp || 0); // fixing missing info in upload
                    }else{
                        copy.score = c.score; // Fallback for scoring_special
                    }
                    cond.push(copy);
                }
            }
            g.group = {
                flat,
                multiplier: mult,
                conditional: cond
            }
        }
        return categories;
    }

    function consolidateActions(stats){
        let con = {};
        if(!stats || !stats.turns) return [];
        let turns = Object.keys(stats.turns).length;
        for(let turn of Object.keys(stats.turns)){
            let t = stats.turns[turn];
            for(let k of Object.keys(t)){
                let a = allActions.filter(a => a.listAs).find(a => a.type == k && a.listAs);
                if(a){
                    a = a.listAs;
                }else{
                    a = allActions.filter(a => a.listAs).find(a => a.listAs[k]);
                    if(a) a = a[k]
                }
                if(!a) [k];
                if(!a) continue;

                if(!con[a]){
                    con[a] = {
                        sum: 0,
                        byTurn: Array(turns)
                    };
                    
                }
                con[a].byTurn[parseInt(turn)] = t[k];
                con[a].sum += t[k];
            }
        }
        return Object.keys(con).map(k => {return {name: k, count: con[k].sum, byTurn: con[k].byTurn}}).sort((a,b) => b.count - a.count);
    }

</script>

<div class="player_breakdown">
    <div on:click={e => {console.log(p);}} class="player {p.captain.toLowerCase()}">
        <div class="player_title">{p.captain}: {@html convert(`${p.score}`)}
            {#if p.bot}
                &nbsp;🤖 
                {#if p.botLevel}
                    ({p.botLevel})
                {/if}
            {/if}
            {#if p.username}(played by {p.username}){/if}
        </div>
        <div>
            {#each [...$res.trackTypes, 'collective', 'treachery'] as t}
                {#if p.hasOwnProperty(t) && typeof p[t] == 'number'}
                    {p[t]}{@html convert(`[[${t}]]`, false)}&nbsp;
                {/if}
            {/each}
            {#each allTokenTypes() as t}
                {#if p[t]}
                    {p[t]}{@html convert(`[[${t}]]`, false)}&nbsp;
                {/if}
            {/each}
            {@html convert('[[away team]]/[[ship]]')}&nbsp; {p.scoreBreakdown.locationScoring || 0}VP
        </div>
        <div class="line"></div>
        {#if p.stats && p.stats.cardsGained}
            <div><div class="subtitle">Cards gained:</div>
                {#each Object.keys(p.stats.cardsGained) as k, i}
                    {#if k == 'none'}
                        No suit:
                    {:else if k != 'redshirt'}
                        {@html convert(`[[${k}]]`, true)}:
                    {:else}
                        {k}:
                    {/if}
                    {p.stats.cardsGained[k]}
                    {#if i < Object.keys(p.stats.cardsGained).length - 1},&nbsp;{/if}
                {/each}
            </div>
            <div class="line"></div>
        {/if}
        {#if p.scoreBreakdown}
            <div>
                <div class="subtitle">Score breakdown:</div>
                {#if p.scoreBreakdown.hasOwnProperty('marked')}
                    <div>Marked cards: {p.scoreBreakdown.marked}</div>
                {/if}
                {#if p.scoreBreakdown.hasOwnProperty('resources')}
                    <div>Resources: {p.scoreBreakdown.resources}</div>
                {/if}
                <table>
                    <tr>
                        <th>Category</th><th>Flat VP ({flatVP || p.scoreBreakdown.cards} VP)</th><th>Multiplied ({p.scoreBreakdown.tracks} VP)</th><th>Endgame ({p.scoreBreakdown.endGame} VP)</th>
                    </tr>
                        {#each categories as set}
                            <tr>
                                <td>{set.name}</td>
                                {#each Object.keys(set.group) as k}
                                    <td style="text-align: left;">
                                        {#each set.group[k] as c}
                                            {@const score = (p.scoreBreakdown.individualCards && p.scoreBreakdown.individualCards[c.id] ? p.scoreBreakdown.individualCards[c.id]: 0)}
                                            {#if findCard($res.cards, c.id)}
                                                <LogCard showFinalScores showStats clickable category={k} textSize=2 c={{...findCard($res.cards, c.id), score,...c}} />
                                            {:else if findCardByName($res.cards, c.name)}
                                                (<LogCard showFinalScores showStats clickable category={k} textSize=2 c={{...findCardByName($res.cards, c.name), score, ...c}} />)
                                            {:else}
                                                {c.name} ({c.id} – no longer in master spreadsheet)
                                            {/if}
                                        {/each}
                                    </td>
                                {/each}
                            </tr>
                        {/each}
                </table>
            </div>
            <details>
                <summary class="subtitle">Full card list</summary>
                <div class="card_list">
                        {#each cards.sort((a,b) => byPlayCount(a,b)) as c}
                            {@const score = (p.scoreBreakdown.individualCards && p.scoreBreakdown.individualCards[c.id] ? p.scoreBreakdown.individualCards[c.id]: 0)}
                            {#if findCard($res.cards, c.id)}
                                <LogCard showFinalScores showStats clickable textSize=2 c={{...findCard($res.cards, c.id), score, ...c}} />
                            {:else if findCardByName($res.cards, c.name)}
                                (<LogCard showFinalScores showStats clickable textSize=2 c={{...findCardByName($res.cards, c.name), score, ...c}} />)
                            {:else}
                                {c.name} ({c.id} – no longer in master spreadsheet)
                            {/if}
                        {/each}
                </div>
            </details>
            <div class="line"></div>
            <div class="action_list">
                <div class="subtitle">Actions taken:</div>
                <!--<ul>
                    {#each actions(p).sort((a, b) => (b.num - a.num)) as a}
                        <li>{a.name}: sum {a.num}, average <Average data={a.list} />, list [{a.list.join(', ')}]</li>
                    {/each}
                </ul>-->
                {#each consolidateActions(p.stats) as a}
                    <ActionBit {a} textSize=2 />
                {/each}
            </div>
        {/if}

    </div>
</div>

<style>

    table {
        border: 1px solid white;
    }

    th {
        border-bottom: 1px solid white;
    }

    .center {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
    }

    .table_label {
        display: flex;
        flex-direction: column;
        align-items: center;
        align-content: center;

    }
    
    .player {
        border: 0.5vmin solid white;
        padding: 1vmin;
        margin-top: 1vmin;
        margin-bottom: 1vmin;
    }

    .player_title {
        font-weight: bold;
        font-size: 2.5vmin; 
        /*text-decoration: underline;*/
    }

    .title {
        font-weight: bold;
        font-size: 3vmin;
        text-decoration: underline;
        margin-bottom: 1vmin;
    }

    .subtitle {
        font-style: italic;
        font-size: 2vmin;
    }

    .basicinfo {
        font-style: italic;
    }

    .line {
        margin-top: 0.5vmin;
        margin-bottom: 0.5vmin;
        width: 100%;
        height: 2px;
        background-color: white;
    }

    table, th, td {
        border: 1px solid white;
        border-collapse: collapse;
        text-align: center;
    }

    .score_item {
        margin-left: 20px;
    }

    .card_list {
        display: flex;
        flex-wrap: wrap;
    }
</style>